import {
	Card,
	CardBody,
	Input,
	TableRow,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import DayRentalPeriodicHikeDayTable from 'components/dayRentalPeriodicHikeDay/DayRentalPeriodicHikeDayTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import DayRentalPeriodicHikeDayServices from 'services/DayRentalPeriodicHikeDayServices';
import { FiPlus } from 'react-icons/fi';
import DayRentalPeriodicHikeDayDrawer from 'components/drawer/DayRentalPeriodicHikeDayDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';

const DayRentalPeriodicHikeDay = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [status, setStatus] = useState('');
	const { data, loading, error } = useAsync(
		DayRentalPeriodicHikeDayServices.getAllDayRentalPeriodicHikeDay
	);

	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const isAdmin = adminInfo?.id === 1;

	const hideView = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'periodic hike' && perm.view === 1
		  );

	const hideDelete = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'periodic hike' && perm.delete === 1
		  );

	const hideEdit = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'periodic hike' && perm.edit === 1
		  );

	const hideAdd = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'periodic hike' && perm.add === 1
		  );

	const hideExport = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'periodic hike' && perm.export === 1
		  );
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		dayRentalPeriodicHikeDayRef,
		dataTable,
		serviceData,
		handleSubmitDayRentalPeriodicHikeDay,
		currentPage,
	} = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);
	const updatedData = safeData.map(({ id, ...rest }) => rest);
    // console.log("day rental data", updatedData);
	
	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const finalData = data?.data?.map((item, itemIndex) => {
  const vehicleIds = item.vehicle_type_id || [];
  const vehicleNames = item.vehicle_type_names || {};

  const vehicleTypes = vehicleIds
    .map((vid) => vehicleNames[vid] || vid)
    .join("\n");

  const hike = vehicleIds
  .map((vid) => {
    const val = item.hike?.[vid];
    return val ? `${val}%` : ""; 
  })
  .join("\n");


  return {
    "SI.No": itemIndex + 1,
    "City": item.city_names, 
	"Start Date": item.start_date, 
	"End Date": item.end_date,
    "Vehicle Type": vehicleTypes, 
    "Hike": hike,
  };
});
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<MainDrawer>
						<DayRentalPeriodicHikeDayDrawer id={serviceId} />
					</MainDrawer>

					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={dayRentalPeriodicHikeDayRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitDayRentalPeriodicHikeDay}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Periodic Rate
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										exportDataXlsx={finalData}
										fileNames="Day Rental Periodic Hike"
									/>
								)}
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData.length ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '65vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<TableRow>
												<TableCell>Sl.No.</TableCell>
												<TableCell>City</TableCell>
												<TableCell>Start Date</TableCell>
												<TableCell>End Date</TableCell>
												<TableCell>Vehicle Type</TableCell>
												<TableCell>Hike (%)</TableCell>

												<TableCell>Actions</TableCell>
											</TableRow>
										</TableHeader>
										<DayRentalPeriodicHikeDayTable
											dayRentalPeriodicHikeDay={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Day Rental Periodic Hikes." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default DayRentalPeriodicHikeDay;
